import styled from "styled-components";

export const Container = styled.div`
    .isOpen {
        max-height: 9999px;
        transition: all 4s;
    }
`;


